export default {
  de: {
    title: 'Druckanbieter',
    create: 'Druckanbieter hinzufügen',
    active: 'aktiv',
    inactive: 'inaktiv',
  },
};
